import { cpf } from 'cpf-cnpj-validator';

export function checkCpf(taxid) {
  var check = true;
  if (!cpf.isValid(taxid)) {
    check = false;
  }

  return check;
}